import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../shared/services/notification.service';
import {
  LocationNotificationsService,
  NotificationSettingsDto
} from '../../../services/location-notifications.service';

/**
 * "Notificaciones" sub-section of the location settings (FAC-45). Toggles
 * for every notification kind + the configurable hours-before for the
 * short reminder.
 */
@Component({
  selector: 'app-location-notifications-section',
  templateUrl: './location-notifications-section.component.html',
  styleUrls: ['./location-notifications-section.component.css'],
  standalone: false
})
export class LocationNotificationsSectionComponent implements OnInit {
  @Input() locationId!: string | null;

  isLoading = false;
  isSaving = false;

  // Field-initialised so the template renders cleanly during the very
  // first change-detection cycle (View Engine eager binding).
  readonly form: FormGroup = new FormGroup({
    reminder24hEnabled: new FormControl(true),
    reminderShortEnabled: new FormControl(true),
    reminderHoursBefore: new FormControl(2, [Validators.required, Validators.min(1), Validators.max(72)]),
    cancellationEnabled: new FormControl(true),
    rescheduleEnabled: new FormControl(true),
    reviewInvitationEnabled: new FormControl(true),
    reviewResponseEnabled: new FormControl(true),
    paymentReceivedEnabled: new FormControl(true),
    refundProcessedEnabled: new FormControl(true)
  });

  constructor(
    private readonly api: LocationNotificationsService,
    private readonly notify: NotificationService
  ) {}

  ngOnInit(): void {
    if (this.locationId) {
      this.load();
    }
  }

  load(): void {
    if (!this.locationId) return;
    this.isLoading = true;
    this.api.getSettings(this.locationId).subscribe({
      next: settings => {
        this.applyDto(settings);
        this.isLoading = false;
      },
      error: () => {
        this.notify.errorBottom('No se ha podido cargar la configuración de notificaciones.');
        this.isLoading = false;
      }
    });
  }

  save(): void {
    if (!this.locationId) return;
    if (this.form.invalid) {
      this.notify.errorBottom('Revisa los campos marcados.');
      return;
    }
    this.isSaving = true;
    this.api.updateSettings(this.locationId, this.form.value).subscribe({
      next: settings => {
        this.applyDto(settings);
        this.isSaving = false;
        this.notify.okBottom('Configuración guardada.');
      },
      error: () => {
        this.notify.errorBottom('No se ha podido guardar.');
        this.isSaving = false;
      }
    });
  }

  private applyDto(s: NotificationSettingsDto): void {
    this.form.patchValue({
      reminder24hEnabled: s.reminder24hEnabled,
      reminderShortEnabled: s.reminderShortEnabled,
      reminderHoursBefore: s.reminderHoursBefore,
      cancellationEnabled: s.cancellationEnabled,
      rescheduleEnabled: s.rescheduleEnabled,
      reviewInvitationEnabled: s.reviewInvitationEnabled,
      reviewResponseEnabled: s.reviewResponseEnabled,
      paymentReceivedEnabled: s.paymentReceivedEnabled,
      refundProcessedEnabled: s.refundProcessedEnabled
    }, { emitEvent: false });
  }
}
